<template>

  <q-input
      class="mw-form-v2-input"
      :filled="settings.theme.input.filled"
      :outlined="settings.theme.input.outlined"
      :standout="settings.theme.input.standout"
      :borderless="settings.theme.input.borderless"
      :rounded="settings.theme.input.rounded"
      :square="settings.theme.input.square"
      :dense="settings.theme.input.dense"

      v-model="fieldValue"
      :label="field.layout_injected_label ? field.layout_injected_label : field.label"

      lazy-rules
      debounce="1000"

      mask="##/##/####"

      :rules="field.required ? [ val => (val && val.length > 9) || requiredText]  : []"

      :hide-bottom-space="hide_bottom_space"
  >
    <template v-slot:append>
      <q-icon name="s_event" class="cursor-pointer">
        <q-popup-proxy cover transition-show="scale" transition-hide="scale">
          <q-date v-model="fieldValue" mask="MM/DD/YYYY">
            <div class="row items-center justify-end">
              <q-btn v-close-popup label="Close" color="primary" flat />
            </div>
          </q-date>
        </q-popup-proxy>
      </q-icon>
    </template>
    <template v-slot:label>
      {{field.layout_injected_label ? field.layout_injected_label : field.label}}
      <OptionalLabel :field="field"></OptionalLabel>
    </template>
  </q-input>

</template>

<script>
import {mapFields} from "vuex-map-fields";
import OptionalLabel from "@/components/OptionalLabel";

export default {
  props: {
    modelValue: {},
    field:{},
    hide_bottom_space: null
  },
  data() {
    return {

    };
  },
  emits: ['update:modelValue'],
  methods: {

  },
  components: {OptionalLabel},
  computed: {
    ...mapFields('settings/list', {
      settings: 'settings'
    }),
    requiredText: function () {
      return this.field.required_text ? this.field.required_text : 'Please select a date';
    },
    fieldValue: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit('update:modelValue', value);
      },
    }
  },
  mounted() {

  }
}
</script>
